import { useEffect } from "react"

import {
  isMediaEncryptionValue,
  MediaEncryption,
} from "@/types/api/SimulatorType"
import { isValidPhoneNumber } from "@/utils/persona/phoneNumberUtils"

/**
 * Clears enabled media encryption after leaving SIP mode or entering a valid
 * phone number in the SIP field. Incomplete SIP edits preserve the setting.
 */
export function useClearMediaEncryptionOutsideSipMode(
  isSipMode: boolean,
  phoneNumber: string,
  mediaEncryption: string | undefined,
  onMediaEncryptionChange: ((value: string) => void) | undefined,
): void {
  useEffect(() => {
    const hasValidPhoneNumber =
      phoneNumber.length > 0 && isValidPhoneNumber(phoneNumber)
    if (
      onMediaEncryptionChange &&
      isMediaEncryptionValue(mediaEncryption) &&
      mediaEncryption !== MediaEncryption.DISABLED &&
      (!isSipMode || hasValidPhoneNumber)
    ) {
      onMediaEncryptionChange(MediaEncryption.DISABLED)
    }
  }, [isSipMode, phoneNumber, mediaEncryption, onMediaEncryptionChange])
}
